import { css } from '@utils/css';

const image = css`
  border: 0;
  display: block;
`;
const basicImage = css`
  height: 100%;
  width: 100%;
`;
const picture = css`
  display: block;
  line-height: 0;
`;

export { basicImage, image, picture };
//# sourceMappingURL=image.js.map
